import React from 'react'

// Eco-delivery designation pill for the tracking header (sc-27222). English-only
// (the app has no i18n framework). Copy/visual are a sensible default pending
// design sign-off (Beth).
//
// Deliberately a plain <span> — NOT a styled-component. The styles live on the
// `.eco-delivery-badge` child selector inside `HeaderInfo` (v2/styles). The app
// has no babel-plugin-styled-components, so styled-components' `sc-*` component
// IDs are counter-based; adding a new styled() call anywhere shifts those hashes
// and breaks the Cypress selectors that hard-code them (cypress/e2e/tests.cy.ts).
// Styling via the existing HeaderInfo block adds no new styled() call.
const EcoDeliveryBadge = () => (
  <span className="eco-delivery-badge" data-testid="eco-delivery-badge">
    <span aria-hidden="true">🌱</span> Eco delivery
  </span>
)

export default EcoDeliveryBadge
